import React from "react";
import { Redirect } from "react-router-dom";

import { toast } from "react-toastify";
import Modal from "react-awesome-modal";
import { Elements, StripeProvider } from "react-stripe-elements";
import { CSSTransition } from "react-transition-group";
import Vimeo from "@u-wave/react-vimeo";
import Switch from "react-switch";

import withServices from "../../../../HOCs/withServices";
import Navbar from "../../../../components/CustomNav/CustomNav.Component";
import CheckoutForm from "../../../Subscription/StripeCheckoutForm/StripeCheckoutForm.Component";

import {
  Container,
  FormWrapper,
  Row,
  ContentWrapper,
  ContentHeading,
  ContentBody,
  InputWrapper,
  CtaWrapper,
  Disclaimer,
  VideoWrapper,
  ModalContainer,
  FeedbackP,
  InputItemsRow,
  PackagesWrapper,
  PackageItem,
} from "../../Common/Common.styles";

interface IProps {
  history?: any;
  services?: any;
}
interface IState {
  firstName: string;
  lastName: string;
  selectedPackage: number;
  amount: number;
  paymentSuccess: boolean;
  feedbackOpen: boolean;
  navigate: boolean;
  destination: string;
}

const vimeoVar = "students_checkout";

class StudentPayment extends React.Component<IProps, any> {
  constructor(props) {
    super(props);

    this.state = {
      firstName: "",
      lastName: "",
      selectedPackage: 0,
      amount: 20,
      paymentSuccess: false,
      feedbackOpen: false,
      hasActiveSubscription: false, // temporary for subscription status
      toLogin: false,
      vimeoID: null,
      packages: [],
      packagesLoaded: false,
      currentPlanType: "MONTHLY",
      planID: null,
    };
    this.submitPaymentDetails = this.submitPaymentDetails.bind(this);
  }
  public async componentDidMount() {
    // check if logged and if hasActivesubscription
    const {
      services: {
        isUserLoggedIn,
        currentBaseUrl,
        currentDesignation,
        adminAPI,
      },
      history,
    } = this.props;
    const { hasActiveSubscription } = this.state;

    if (!isUserLoggedIn) {
      history.replace("/login");
    } else {
      const [vimeoRes, packagesRes] = await Promise.all([
        adminAPI.fetchVimeoSystemVar(vimeoVar),
        adminAPI.getPackagesList(),
      ]);
      if (vimeoRes.ok) {
        const vimeoID = vimeoRes.data.value;
        const packages = packagesRes.data.packages;
        this.setState({
          vimeoID,
          vimeoLoaded: true,
          packages,
          packagesLoaded: true,
        });
      }
    }
    if (hasActiveSubscription) {
      history.replace(
        `${currentBaseUrl}/preassessmentresult/${currentDesignation}`
      );
    }
  }

  public logOut = () => {
    this.setState({ toLogin: true });
  };

  // checkoutform methods
  public togglePaymentState() {
    // to come
  }

  public async submitPaymentDetails(token) {
    // trigger on stripe success
    const {
      firstName,
      lastName,
      selectedPackage,
      currentPlanType,
      packages,
    } = this.state;
    const {
      services: { fixturesAPI, studentsAPI },
    } = this.props;

    const currentPackage = packages.find((p) => p.id === selectedPackage);
    const currentPlan = currentPackage.Plans.find(
      (plan) => plan.type === currentPlanType
    );

    if (!token) {
      toast.error("Error! Could not process card!");
      return;
    }
    const payload = {
      firstName,
      lastName,
      payment_method_id: token,
      pk: selectedPackage,
      plan_id: currentPlan.id,
      plan_type: currentPlan.type,
    };

    console.log("Payload: " + JSON.stringify(payload, null, 2));
    const cardSuccess = await studentsAPI.makePayment(payload);
    if (cardSuccess.ok) {
      this.setState({ paymentSuccess: true, feedbackOpen: true });
    } else {
      this.setState({ paymentSuccess: false, feedbackOpen: true });
    }
    // this.props.history.push("/login");
  };

  public isSignupFilled = () => {
    if (this.state.firstName.length < 1 || this.state.lastName.length < 1) {
      toast.warn("Please fill all the fields!");
      return false;
    } else {
      return true;
    }
  };

  public StartProcessing() {
    // start processing stripe
    // may not be useful
  }
  public closeModal = (status) => {
     const {
       services: { currentBaseUrl },
     } = this.props;
     if (status === true) {
       // sign up was successful, go to login
       this.props.history.goBack();
     }
    this.setState({feedbackOpen: false})
  }

  public handleChange = (event) => {
    const valname = event.currentTarget.dataset.arg;
    this.setState({ [valname]: event.target.value });
  };

  public togglePlanType = () => {
    const { currentPlanType } = this.state;
    if (currentPlanType === "MONTHLY") {
      this.setState({ currentPlanType: "YEARLY" });
    }
    if (currentPlanType === "YEARLY") {
      this.setState({ currentPlanType: "MONTHLY" });
    }
  };

  public packageSelectedHandler = (pk, planID) => {
    this.setState({ selectedPackage: pk, planID });
  };

  public renderVimeo = () => {
    const { vimeoID, vimeoLoaded } = this.state;
    if (vimeoLoaded) {
      return (
        <Vimeo
          className="prepayment-video"
          video={`https://player.vimeo.com/video/${vimeoID}`}
          width={582}
          responsive={true}
        />
      );
    } else {
      return <div />;
    }
  };

  public renderFeedbackModal = () => {
    const { feedbackOpen, paymentSuccess } = this.state;
    if (feedbackOpen) {
      let content = (
        <FeedbackP success={paymentSuccess}>
          <span>Payment Successful! </span>
          <br /> You now have access to alL Performance Learning features!
        </FeedbackP>
      );
      if (!paymentSuccess) {
        content = (
          <FeedbackP success={paymentSuccess}>
            <span>Payment Failed! </span>
            <br /> check your card details and try again!
          </FeedbackP>
        );
      }
      return (
        <Modal
          visible={feedbackOpen}
          effect="fadeInUp"
          onClickAway={this.closeModal.bind(this, paymentSuccess)}
        >
          <ModalContainer>{content}</ModalContainer>
        </Modal>
      );
    } else {
      console.log("no feedback yet");
      return;
    }
  };

  public renderPackages = () => {
    const { packages, packagesLoaded, currentPlanType } = this.state;
    if (packagesLoaded) {
      return (
        <React.Fragment>
          {/* <h1 className="package-heading">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet,
            dolores?
          </h1> */}

          <div className="toggle-plan-wrapper">
            <p className="plan-type">Monthly</p>
            <Switch
              checked={this.state.currentPlanType === "YEARLY"}
              onChange={this.togglePlanType}
              offColor="#75db00"
              onColor="#75db00"
              offHandleColor="#fff"
              aria-labelledby="switch-label"
              checkedIcon={false}
              uncheckedIcon={false}
            />
            <p className="plan-type">Yearly</p>
          </div>
          <PackagesWrapper>
            {packages.map((item) => {
              const currentPlan = item.Plans.find(
                (plan) => plan.type === currentPlanType
              );
              const monthlyPlan = item.Plans.find(
                (plan) => plan.type === "MONTHLY"
              );
              const yearlyPlan = item.Plans.find(
                (plan) => plan.type === "YEARLY"
              );
              const savings = 12 * monthlyPlan.price - yearlyPlan.price;

              console.log("CurrentPlan" + JSON.stringify(currentPlan));

              return (
                <PackageItem key={`package${item.id}`}>
                  <div className="package-name">
                    <h1 className="package-title">{item.Name}</h1>
                    {/* <p className="package-target">For individual learners needing that sustainable boost in their performance</p> */}
                  </div>
                  <div className="package-value">
                    <h1 className="price">
                      <sup>&pound;</sup>
                      {currentPlan.price}
                      <span>/p/m</span>
                    </h1>
                    {currentPlanType === "YEARLY" ? (
                      <h1 className="price">
                        <span>You Save:</span>
                        &pound;{savings}
                      </h1>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="features-list">
                    <p className="package-target">
                      For individual learners needing that sustainable boost in
                      their performance
                    </p>
                    <button
                      className={`package-button ${
                        this.state.selectedPackage === item.id ? "selected" : ""
                      }`}
                      onClick={this.packageSelectedHandler.bind(
                        this,
                        item.id,
                        currentPlan.id
                      )}
                    >
                      {this.state.selectedPackage === item.id ? (
                        <p className="p-selected-package">
                          <i
                            className="fa fa-check"
                            style={{ fontSize: "18px", color: "#000" }}
                          />
                          Selected
                        </p>
                      ) : (
                        <p className="p-selected-package">Select</p>
                      )}
                    </button>
                  </div>
                </PackageItem>
              );
            })}
          </PackagesWrapper>
        </React.Fragment>
      );
    } else {
      console.log("Packages Loading...");
      return;
    }
  };
  public render() {
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }
    return (
      <CSSTransition in={true} appear={true} classNames="fade" timeout={1000}>
        <Container>
          <Navbar logoutParent={this.logOut} />
          <Row>
            {this.renderFeedbackModal()}
            <ContentWrapper>
              <ContentHeading>Checkout</ContentHeading>
              {/* <ContentBody>
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                aliquam erat volutpat. Ut wisi enim ad minim <br />
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
              </ContentBody> */}
              {this.renderPackages()}
              {this.renderVimeo()}
            </ContentWrapper>
            <FormWrapper>
              <ContentBody>Add your payment details</ContentBody>
              <form>
                <InputItemsRow>
                  <InputWrapper>
                    <p>First Name</p>
                    <input
                      className="custom-textfield checkout-input"
                      type="text"
                      name="firstName"
                      id="first-name"
                      placeholder="First Name"
                      onChange={this.handleChange}
                      required={true}
                      data-arg="firstName"
                    />
                  </InputWrapper>
                  <InputWrapper>
                    <p>Last Name</p>
                    <input
                      className="custom-textfield checkout-input"
                      type="text"
                      name="lastName"
                      id="last-name"
                      placeholder="Last Name"
                      onChange={this.handleChange}
                      required={true}
                      data-arg="lastName"
                    />
                  </InputWrapper>
                </InputItemsRow>
              </form>
              <StripeProvider apiKey={this.props.services.stripeKey}>
                <div className="stripe-elems" style={{ padding: "auto 1em" }}>
                  <Elements>
                    <CheckoutForm
                      togglePaymentState={this.togglePaymentState}
                      amount={this.state.amount}
                      onSuccess={this.submitPaymentDetails}
                      formFilled={this.isSignupFilled}
                      StartProcessing={this.StartProcessing}
                    />
                  </Elements>
                </div>
              </StripeProvider>
            </FormWrapper>
          </Row>
        </Container>
      </CSSTransition>
    );
  }
}

export default withServices(StudentPayment);



// WEBPACK FOOTER //
// ./src/pages/Onboard/Student/Payment/StudentPayment.Component.tsx